import React from "react";
import "./ActionButton.css";

const ActionButton = ({
  text,
  onClick,
}) => (
  <div className="action-button-container crca-action-button very-top" onClick={ onClick }>
    <span className="chat-icon"/>
    <span className=" crca-action-button-text action-button-text">{ text }</span>
  </div>
);

export default ActionButton;
